import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class TimeClockService {
  private url = GlobalService.serverURL + 'recruiter/manage_time_clock/';
  private empTimeLogUrl = GlobalService.serverURL + 'recruiter/employee_time_log/';
  private exportCSVUrl = GlobalService.serverURL + 'recruiter/report/';
  constructor(private http:HttpClient) { }

  getTodayData(data){
    return this.http.post(this.url + "get_today_timeclock", data, { headers });
  }
  getTodayList(data){
    return this.http.post(this.url + "get_today_timeclock_data", data, { headers });
  }
  manageTimeClock(data){
    return this.http.post(this.url + "emp_clockin_data", data, { headers });
  }
  getTimesheet(data){
    return this.http.post(this.url + "get_timesheet", data, { headers });
  }
  getEmpTimesheet(data){
    return this.http.post(this.url + "get_userwise_timesheet", data, { headers });
  }
  getJobInsight(data){
    return this.http.post(this.url + "get_job_insight", data, { headers });
  }
  getJobInsightEmp(data){
    return this.http.post(this.url + "get_job_insight_specific", data, { headers });
  }
  getSpecificInsightSub(data){
    return this.http.post(this.url + "get_job_insight_jsc_specific", data, { headers });
  }
  getSpecificInsightSubC(data){
    return this.http.post(this.url + "get_job_insight_specific_subcategory", data, { headers });
  }
//  main time clock lobby
  addCard(data){
    return this.http.post(this.url + "create_timeclock", data, { headers });
  }
  getTimeClockList(data){
    return this.http.post(this.url + "get_timeclock", data, { headers });
  }
  assignClockCard(data){
    return this.http.post(this.url + "assign_timeclock", data, { headers });
  }
  editAssignClockCard(data){
    return this.http.post(this.url + "edit_assign_timeclock", data, { headers });
  }
  getAssignClock(data){
    return this.http.post(this.url + "get_timeclock_assign_emp", data, { headers });
  }
  deleteCard(data){
    return this.http.post(this.url + "delete_timeclock", data, { headers });
  }
  getTodayTracking(data){
    return this.http.post(this.url + "get_today_timeclock_tracking", data, { headers });
  }
  getTodayTrackingById(data){
    return this.http.post(this.url + "get_today_timeclock_insight", data, { headers });
  }
  changeTime(data){
    return this.http.post(this.empTimeLogUrl + "change_time", data, { headers });
  }
  approveTimeSheets(data){
    return this.http.post(this.empTimeLogUrl + "lock_records", data, { headers });
  }
  notclockInDate(data){
    return this.http.post(this.url + "not_clock_in", data, { headers });
  }
  addSeprateEmployeeTime(data){
    return this.http.post(this.empTimeLogUrl + "cmp_add_emp_time", data, { headers });
  }
  exportCSV = (data: {}): any => {
    return this.http.post(this.exportCSVUrl + 'get_job_insight_specific', data, { headers });
  }
  exportUserWiseTimesheetCSV = (data: {}): any => {
    return this.http.post(this.exportCSVUrl + 'get_userwise_timesheet', data, { headers });
  }
}
